import script from "./QuestionnaireQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionnaireQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionnaireQuestion.vue?vue&type=style&index=0&id=f5e02c34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5e02c34"]])

export default __exports__